export default "__VITE_ASSET__tbz348a0__"